import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, map, Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../core/services/auth/auth.service';
import { MessagePopupComponent } from '../../shared/components/message-popup/message-popup.component';
import { PopupService } from '../../core/../core/services/popup/popup.service';

@Injectable({
	providedIn: 'root'
})

export class RegistrationService {

	private sb_url = environment.do_services_sb_url;
	private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
	private accountInfoUrl = 'generic/getAccountType';
	private countriesUrl = 'country/getCountriesList';
	private userRegisterUrl = 'gigya/gigyaRegistration';
	private indUserRegisterUrl = 'userDetails/insertIndividualUsers';
	private checkVatUrl = 'consumer/checkVatApprox';
	private mailToAdminUrl = 'generic/mailToAdmin';
	private checkEinvoiceAddressLineUrl = 'gis/directoryLine';

	constructor(private http: HttpClient, private authService: AuthService,
				private popupService: PopupService, private route: Router) { }

	mailToAdmin(mailObject: string): Observable<any> {
		return this.http.post(this.sb_url + this.mailToAdminUrl, mailObject, { responseType: 'text' })
			.pipe(
				map((response: any) => {
					const run = response;
					return run;
				}),
				catchError((e: any) => this.handleError(e))
			);
	}

	getAccountType(): Observable<any> {
		return this.http.get(this.sb_url + this.accountInfoUrl, { responseType: 'text' })
			.pipe(
				map((response: any) => {
					const run = response;
					return run;
				}),
				catchError((e: any) => this.handleError(e))
			);
	}

	getCountries(): Observable<any> {
		return this.http.get(this.sb_url + this.countriesUrl, { responseType: 'text' })
			.pipe(
				map((response: any) => {
					const run = response;
					return run;
				}),
				catchError((e: any) => this.handleError(e))
			);
	}

	registerUser(registerUserInfo: string) {
		const options = {
			headers: this.headers
		}
		return this.http.post(this.sb_url + this.userRegisterUrl, registerUserInfo, options)
			.pipe(
				map((response: any) => {
					const run = response;
					return run;
				}),
				catchError((e: any) => this.handleError(e))
			);
	}

	registerIndividualUser(registerUserInfo: string, edit: boolean) {
		const options = {
			headers: this.headers
		}
		return this.http.post(this.sb_url + this.indUserRegisterUrl + '/' + edit, registerUserInfo, options)
			.pipe(
				map((response: any) => {
					const run = response;
					return run;
				}),
				catchError((e: any) => this.handleError(e))
			);
	}

	checkVat(vatRequest: string): Observable<any> {
        const options = {
			headers: this.headers
	    };
		return this.http.post(this.sb_url + this.checkVatUrl, vatRequest, { responseType: 'text' })
			.pipe(
				map((response: any) => {
					const run = response;
					return run;
				}),
				catchError((e: any) => this.handleError(e))
			);
	}

	checkEinvoiceAddressLine(einvoiceAddressLineRequest: string): Observable<any> {
        const options = {
			headers: this.headers
	    };
		return this.http.post(this.sb_url + this.checkEinvoiceAddressLineUrl, einvoiceAddressLineRequest, { responseType: 'text' })
			.pipe(
				map((response: any) => {
					const run = response;
					return run;
				}),
				catchError((e: any) => this.handleError(e))
			);
	}

	private handleError(error: any): Observable<never> {
        if([400, 403, 404, 405, 500, 502, 503, 504].includes(error.status)) {
            return throwError(() => error);
        }
        if(error.status === 401) {
			const dialogRef = this.popupService.openDialog(MessagePopupComponent, {
				data: { message: 'Unauthorized Request - Your Session has expired' }
			});
			dialogRef.afterClosed().subscribe(() => {
				this.authService.logout().subscribe(() => {
					this.route.navigate(['/home']);
				});
			});
			return throwError(() => new Error('Unauthorized Request - Session expired'));
		}
        return throwError(() => new Error(`Unhandled status code: ${error.status}`));
    }

}